import api from '@/services/api';
import type {
  RoleListParams,
  RoleRecord,
  RoleSummary,
  RoleUsersParams,
  RoleUsersResponse,
} from '../types/roles.types';

const rolesPath = '/rbac/roles';

export const fetchRoles = async (params: RoleListParams = {}): Promise<RoleSummary[]> => {
  const response = await api.get<RoleSummary[]>(rolesPath, { params });
  return response.data;
};

export const fetchRoleById = async (id: string): Promise<RoleRecord> => {
  const response = await api.get<RoleRecord>(`${rolesPath}/${id}`);
  return response.data;
};

export const fetchRoleUsers = async (
  id: string,
  params: RoleUsersParams,
): Promise<RoleUsersResponse> => {
  const response = await api.get<RoleUsersResponse>(`${rolesPath}/${id}/users`, { params });
  return response.data;
};
